module.exports = __webpack_public_path__ + "static/media/DevMountain - Hexagon 1.7f0a135c.png";